import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top",
  "use": "icon-top-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-top\">\n<path d=\"M107.7,187.4c-1.1,10.1-15.2,9.2-15.7,0c0-7,0-109.3,0-109.3l-48.4,46.7c-7.6,6.5-16.6-3.9-11-10.8\n\tC54,93.2,92.5,56,93.4,55.2c3.5-3.9,9.1-4.1,12.9,0c7.1,6.8,59.4,57.3,61,59.2c5.3,6.6-3.3,16.4-10.6,10.9c-1.9-1.6-49-47.1-49-47.1\n\t M32.5,20.7h134.1v15.2H32.5V20.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol